import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { isUndefined } from 'lodash'
import { ApiResult } from 'src/Libs/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { AuthFetchWithResponse } from 'src/Types/api'

export const fetchWallboxChargingStatus = async (
  authFetch: AuthFetchWithResponse,
  storageId?: string,
  wallboxIndex?: number
): Promise<ApiResult<boolean, AuthFetchError | Error>> => {
  if (isUndefined(storageId) || isUndefined(wallboxIndex)) {
    return new ApiResult<boolean, AuthFetchError | Error>(null, true)
  }
  try {
    const response = await authFetch<boolean>({
      path: `wallboxes/${storageId}/${wallboxIndex}/charging-session/abort`,
    })

    if (!isUndefined(response)) {
      const typedResponse = response as unknown as boolean
      return new ApiResult<boolean, AuthFetchError | Error>(typedResponse)
    }
    return new ApiResult<boolean, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<boolean>(error)
  }
}
